export const DATE_FMT = "MMMM d, yyyy"; // date-fns formatting

export const DATE_FMT_INTERNAL = "yyyy-MM-dd";

export const MAX_GOALS = 5;
